import Vue from 'vue';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';


export class QuestionnairesService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();
    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getQuestions(kyoten: string, id?: number) {
        const { result, error } = await this.commonService.get(id
            ? `${this.baseAPI}/admin/questionnaire/${id}`
            : `${this.baseAPI}/admin/questionnaire?q=kyotenCd=${kyoten}`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getQuestions');
            return;
        }
    }

    public async editQuestion(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/questionnaire`, { ...data });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editProposal');
            return;
        }
    }

    public async deleteQuestion(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/admin/questionnaire/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteQuestion');
            return;
        }
    }

    public async saveQuestions(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/admin/questionnaires`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveQuestions');
            return;
        }
    }


}
